/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToApiResponse, convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminCreatePalletOrderRequest,
    AdminCreatePalletOrderRequestFromJSON,
    AdminCreatePalletOrderRequestToJSON,
    AdminCreatePalletOrderResponse,
    AdminCreatePalletOrderResponseFromJSON,
    AdminCreatePalletOrderResponseToJSON,
    AdminPalletOrder,
    AdminPalletOrderFromJSON,
    AdminPalletOrderToJSON,
    AdminPalletOrderLookupResponse,
    AdminPalletOrderLookupResponseFromJSON,
    AdminPalletOrderLookupResponseToJSON,
    AdminUpdatePalletOrderAttachmentMetaRequest,
    AdminUpdatePalletOrderAttachmentMetaRequestFromJSON,
    AdminUpdatePalletOrderAttachmentMetaRequestToJSON,
    AdminUpdatePalletOrderRequest,
    AdminUpdatePalletOrderRequestFromJSON,
    AdminUpdatePalletOrderRequestToJSON,
} from '../models';

export interface AdminPalletOrderApiAdminCreatePalletRequest {
    params: AdminCreatePalletOrderRequest;
}

export interface AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest {
    id: number;
    fileName: string;
    attachment?: Blob;
}

export interface AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest {
    id: number;
    attachmentId: number;
}

export interface AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest {
    id: number;
    attachmentId: number;
}

export interface AdminPalletOrderApiAdminGetPalletRequest {
    id: number;
}

export interface AdminPalletOrderApiAdminPalletOrderLookupRequest {
    id: number;
    name: string;
}

export interface AdminPalletOrderApiAdminUpdatePalletRequest {
    id: number;
    params: AdminUpdatePalletOrderRequest;
}

export interface AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest {
    id: number;
    params: AdminUpdatePalletOrderAttachmentMetaRequest;
}

export function createAdminCreatePalletPath(): string {
    return `/admin/pallet_orders`;
}
export function createAdminCreatePalletFullPath(): string {
    return runtime.BASE_PATH + `/admin/pallet_orders`;
}
export function createAdminCreatePalletOrderAttachmentPath(id: string): string {
    return `/admin/pallet_orders/{id}/attachments`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminCreatePalletOrderAttachmentFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/pallet_orders/{id}/attachments`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminDeletePalletOrderAttachmentPath(id: string, attachmentId: string): string {
    return `/admin/pallet_orders/{id}/attachments/{attachment_id}`
        .replace(`{${'id'}}`, encodeURIComponent(id))
        .replace(`{${'attachment_id'}}`, encodeURIComponent(attachmentId));
}
export function createAdminDeletePalletOrderAttachmentFullPath(id: string, attachmentId: string): string {
    return (
        runtime.BASE_PATH +
        `/admin/pallet_orders/{id}/attachments/{attachment_id}`
            .replace(`{${'id'}}`, encodeURIComponent(id))
            .replace(`{${'attachment_id'}}`, encodeURIComponent(attachmentId))
    );
}
export function createAdminDownloadPalletOrderAttachmentPath(id: string, attachmentId: string): string {
    return `/admin/pallet_orders/{id}/attachments/{attachment_id}`
        .replace(`{${'id'}}`, encodeURIComponent(id))
        .replace(`{${'attachment_id'}}`, encodeURIComponent(attachmentId));
}
export function createAdminDownloadPalletOrderAttachmentFullPath(id: string, attachmentId: string): string {
    return (
        runtime.BASE_PATH +
        `/admin/pallet_orders/{id}/attachments/{attachment_id}`
            .replace(`{${'id'}}`, encodeURIComponent(id))
            .replace(`{${'attachment_id'}}`, encodeURIComponent(attachmentId))
    );
}
export function createAdminGetPalletPath(id: string): string {
    return `/admin/pallet_orders/{id}`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminGetPalletFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/pallet_orders/{id}`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminPalletOrderLookupPath(id: string): string {
    return `/admin/pallet_orders/{id}/lookup`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminPalletOrderLookupFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/pallet_orders/{id}/lookup`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminUpdatePalletPath(id: string): string {
    return `/admin/pallet_orders/{id}`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminUpdatePalletFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/pallet_orders/{id}`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminUpdatePalletOrderAttachmentMetadataPath(id: string): string {
    return `/admin/pallet_orders/attachments/{id}/metadata`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminUpdatePalletOrderAttachmentMetadataFullPath(id: string): string {
    return (
        runtime.BASE_PATH +
        `/admin/pallet_orders/attachments/{id}/metadata`.replace(`{${'id'}}`, encodeURIComponent(id))
    );
}

/**
 *
 */
export class AdminPalletOrderApi extends runtime.BaseAPI {
    /**
     * Create a new pallet order
     * Create a new pallet order
     */
    async adminCreatePallet(
        requestParameters: AdminPalletOrderApiAdminCreatePalletRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminCreatePalletOrderResponse>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminCreatePallet.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminCreatePalletPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminCreatePalletOrderRequestToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) =>
                      AdminCreatePalletOrderResponseFromJSON(jsonValue)
                  )
        );
    }
    /**
     * Create a new attachment for a pallet order
     * Create a new attachment for a pallet order
     */
    async adminCreatePalletOrderAttachment(
        requestParameters: AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminCreatePalletOrderAttachment.'
            );
        }

        if (requestParameters?.fileName === null || requestParameters?.fileName === undefined) {
            throw new runtime.RequiredError(
                'fileName',
                'Required parameter requestParameters.fileName was null or undefined when calling adminCreatePalletOrderAttachment.'
            );
        }

        const queryParameters: any = {};

        if (requestParameters?.fileName !== undefined) {
            queryParameters['fileName'] = requestParameters.fileName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        const consumes: runtime.Consume[] = [{contentType: 'multipart/form-data'}];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: {append(param: string, value: any): any};
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters?.attachment !== undefined) {
            formParams.append('attachment', requestParameters.attachment as any);
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminCreatePalletOrderAttachmentPath(String(requestParameters?.id)),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: formParams,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * Delete an attachment for a pallet order
     * Delete an attachment for a pallet order
     */
    async adminDeletePalletOrderAttachment(
        requestParameters: AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminDeletePalletOrderAttachment.'
            );
        }

        if (requestParameters?.attachmentId === null || requestParameters?.attachmentId === undefined) {
            throw new runtime.RequiredError(
                'attachmentId',
                'Required parameter requestParameters.attachmentId was null or undefined when calling adminDeletePalletOrderAttachment.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminDeletePalletOrderAttachmentPath(
                        String(requestParameters?.id),
                        String(requestParameters?.attachmentId)
                    ),
                    method: 'DELETE',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * Download an attachment for a pallet order
     * Download an attachment for a pallet order
     */
    async adminDownloadPalletOrderAttachment(
        requestParameters: AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<Blob>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminDownloadPalletOrderAttachment.'
            );
        }

        if (requestParameters?.attachmentId === null || requestParameters?.attachmentId === undefined) {
            throw new runtime.RequiredError(
                'attachmentId',
                'Required parameter requestParameters.attachmentId was null or undefined when calling adminDownloadPalletOrderAttachment.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminDownloadPalletOrderAttachmentPath(
                        String(requestParameters?.id),
                        String(requestParameters?.attachmentId)
                    ),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.BlobApiResponse(response));
    }
    /**
     * Get a pallet order by id
     * Get a pallet order by id
     */
    async adminGetPallet(
        requestParameters: AdminPalletOrderApiAdminGetPalletRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminPalletOrder>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminGetPallet.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminGetPalletPath(String(requestParameters?.id)),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminPalletOrderFromJSON(jsonValue))
        );
    }
    /**
     * Lookup products by pallet order
     * Lookup products by pallet order
     */
    async adminPalletOrderLookup(
        requestParameters: AdminPalletOrderApiAdminPalletOrderLookupRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminPalletOrderLookupResponse>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminPalletOrderLookup.'
            );
        }

        if (requestParameters?.name === null || requestParameters?.name === undefined) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter requestParameters.name was null or undefined when calling adminPalletOrderLookup.'
            );
        }

        const queryParameters: any = {};

        if (requestParameters?.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminPalletOrderLookupPath(String(requestParameters?.id)),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) =>
                      AdminPalletOrderLookupResponseFromJSON(jsonValue)
                  )
        );
    }
    /**
     * Update a pallet order
     * Update a pallet order
     */
    async adminUpdatePallet(
        requestParameters: AdminPalletOrderApiAdminUpdatePalletRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminUpdatePallet.'
            );
        }

        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminUpdatePallet.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminUpdatePalletPath(String(requestParameters?.id)),
                    method: 'PUT',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminUpdatePalletOrderRequestToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * Update metadata for a pallet order attachment
     * Update metadata for a pallet order attachment
     */
    async adminUpdatePalletOrderAttachmentMetadata(
        requestParameters: AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminUpdatePalletOrderAttachmentMetadata.'
            );
        }

        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminUpdatePalletOrderAttachmentMetadata.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminUpdatePalletOrderAttachmentMetadataPath(String(requestParameters?.id)),
                    method: 'PUT',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminUpdatePalletOrderAttachmentMetaRequestToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
}
